import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const DashboardFilters = ({
  year,
  employee,
  employees,
  years,
  onYearChange,
  onEmployeeChange,
  onExport,
  loading,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
        alignItems: { xs: "stretch", sm: "center" },
        justifyContent: { xs: "stretch", sm: "flex-end" },
        width: { xs: "100%", sm: "auto" },
      }}
    >
      <FormControl
        sx={{ minWidth: { xs: "100%", sm: 160 } }}
        size={isMobile ? "small" : "medium"}
      >
        <InputLabel id="employee-label">Marketing</InputLabel>
        <Select
          labelId="employee-label"
          id="employee"
          name="employee"
          label="Marketing"
          value={employee}
          onChange={(e) => onEmployeeChange(Number(e.target.value))}
          disabled={loading}
          size="small"
        >
          <MenuItem value={0}>Semua</MenuItem>
          {employees.map((x) => (
            <MenuItem key={x.id} value={Number(x.id)}>
              {x.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        sx={{ minWidth: { xs: "100%", sm: 120 } }}
        size={isMobile ? "small" : "medium"}
      >
        <InputLabel id="year-label">Tahun</InputLabel>
        <Select
          labelId="year-label"
          id="year"
          name="year"
          label="Tahun"
          value={year}
          onChange={(e) => onYearChange(e.target.value)}
          disabled={loading}
          size="small"
        >
          {years.map((x) => (
            <MenuItem key={x} value={x}>
              {x}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        variant="contained"
        onClick={onExport}
        disabled={loading}
        size="medium"
        // sx={{
        //   minWidth: { xs: "100%", sm: 120 },
        //   py: { xs: 1, sm: 1.5 },
        // }}
      >
        Export
      </Button>
    </Box>
  );
};

export default DashboardFilters;
